import * as React from 'react';
import * as styles from './commentShow.css';

import { EditCommentButtonContainer } from '../../containers/EditCommentButtonContainer';
import { DeleteCommentButtonContainer } from '../../containers/DeleteCommentButtonContainer';

export interface ICommentShowProps {
  comment: string;
  entityId: number;
}

export class CommentShow extends React.PureComponent<ICommentShowProps, {}> {
  public render() {
    const { comment, entityId } = this.props;

    return (
      <div className={styles['container']}>
        <span>{comment}</span>
        <div className={styles.comment_controls}>
          <EditCommentButtonContainer entityId={entityId} />
          <DeleteCommentButtonContainer entityId={entityId} />
        </div>
      </div>
    );
  }
}
